<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Procedimentos Preventivos"
            description="Pessoas e procedimentos odontológicos preventivos."
            url="/saude-bucal"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from './SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Procedimentos Odontológicos Preventivos',
    titleTemplate: null,
  },
  data() {
    return {
      linksAjudaPec: [],
      linksAjudaCds: [],
    }
  },
}
</script>

<style></style>
